import gql from 'graphql-tag';

export default gql`
fragment AdminBannerAllData on AdminBanner {
    id
    name
    active_from
    active_to
    url
    url_target
    image_url_desktop
    image_url_mobile
    is_active
    priority
    created_at
    updated_at
    banner_places {
        id
        name
        type_id
    }
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminBannerAllData.ts